import React from "react";
import QRInfo from "components/home/QRInfo";
import History from "components/home/History";
import Profile from "components/common/Profile";
import Detergent from "components/home/Detergent";
import { useParams } from "react-router-dom";

const Home = () => {
  const { page } = useParams();

  return (
    <>
      <Profile />
      {page !== "detergent" && <QRInfo /> }
      {page === "history" && <History />}
      {page === "detergent" && <Detergent />}
    </>
  );
};

export default Home;
